import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import MultipleSuggestedInput_styles from "./MultipleSuggestedInput.styles.js";
const OptionText = (t0)=>{
    const $ = c(26);
    const { inputValue, option } = t0;
    const { classes } = MultipleSuggestedInput_styles();
    let before;
    let index;
    let t1;
    let t2;
    if ($[0] !== inputValue || $[1] !== option) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            index = option.toLowerCase().indexOf(inputValue.toLowerCase());
            if (!inputValue || option === inputValue || -1 === index) {
                let t3;
                if ($[6] !== option) {
                    t3 = /*#__PURE__*/ jsx("div", {
                        children: option
                    });
                    $[6] = option;
                    $[7] = t3;
                } else t3 = $[7];
                t2 = t3;
                break bb0;
            }
            before = option.substring(0, index);
            t1 = option.substring(index, index + inputValue.length);
        }
        $[0] = inputValue;
        $[1] = option;
        $[2] = before;
        $[3] = index;
        $[4] = t1;
        $[5] = t2;
    } else {
        before = $[2];
        index = $[3];
        t1 = $[4];
        t2 = $[5];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const match = t1;
    let t3;
    if ($[8] !== index || $[9] !== inputValue.length || $[10] !== option) {
        t3 = option.substring(index + inputValue.length);
        $[8] = index;
        $[9] = inputValue.length;
        $[10] = option;
        $[11] = t3;
    } else t3 = $[11];
    const after = t3;
    let t4;
    if ($[12] !== before || $[13] !== classes.normalText || $[14] !== index) {
        t4 = !!index && /*#__PURE__*/ jsx("span", {
            className: classes.normalText,
            children: before
        });
        $[12] = before;
        $[13] = classes.normalText;
        $[14] = index;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== classes.highlightedText || $[17] !== match) {
        t5 = /*#__PURE__*/ jsx("span", {
            className: classes.highlightedText,
            children: match
        });
        $[16] = classes.highlightedText;
        $[17] = match;
        $[18] = t5;
    } else t5 = $[18];
    let t6;
    if ($[19] !== after || $[20] !== classes.normalText) {
        t6 = /*#__PURE__*/ jsx("span", {
            className: classes.normalText,
            children: after
        });
        $[19] = after;
        $[20] = classes.normalText;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== t4 || $[23] !== t5 || $[24] !== t6) {
        t7 = /*#__PURE__*/ jsxs("div", {
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[22] = t4;
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
    } else t7 = $[25];
    return t7;
};
export { OptionText };
